import { render, staticRenderFns } from "./DolchAndSpace.vue?vue&type=template&id=07c319aa&scoped=true&"
import script from "./DolchAndSpace.vue?vue&type=script&lang=js&"
export * from "./DolchAndSpace.vue?vue&type=script&lang=js&"
import style0 from "./DolchAndSpace.vue?vue&type=style&index=0&id=07c319aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c319aa",
  null
  
)

export default component.exports